import { render, staticRenderFns } from "./PalletInTunnelList.vue?vue&type=template&id=6d9e11c8"
import script from "./PalletInTunnelList.vue?vue&type=script&lang=js"
export * from "./PalletInTunnelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports